/** @jsx jsx */
/* eslint-disable no-use-before-define */
import { jsx } from '@emotion/core'
import { sectionCss } from '../style'

import React from 'react'
import useSectorActivity from './use-sector-activity'
import SectorRankings from './sector-rankings'
import RatingFieldset from '../rating-fieldset'
import {Loading, fmt, Disclosures, Paging} from '../../twd/twd'


export default () => {
    const { rating, setRating, maturity, setMaturity, sectors, status, total } = useSectorActivity()
    const [page, setPage] = React.useState(1)

    return (
    <React.Fragment>
    <div id="sector-activity-search" className="vertical-offset-sm"></div>
    <div data-name="corporate-sector-activity" className="container vertical-offset-sm" css={sectionCss}>
    <div className="row vertical-offset-sm"></div>

        <div className="row vertical-offset-xs">
        <div className="col-md-12 col-xs-12">
            <h3 className="medium-header">Sector Activity Search</h3>
            There were {fmt.count(total)} TRACE-reportable corporate bond trades in the last trading day.
            Search offerings from the top three issuers, within the prior session's most active sectors.
        </div>
        </div>

        <div className="row vertical-offset-sm">
        <div className="col-md-12 col-xs-12">

        <div className="container" style={{backgroundColor:"#f6f6f6"}}>
            <div className="row vertical-offset-xs"></div>

            <div className="row">
            <div className="col-md-12 col-xs-12">

            <RatingFieldset
                name='corporates-market-top-sectors-rating'
                dataName='corporates-market-top-sectors-rating'
                align='left'
                rating={rating}
                setRating={(r) => {
                    setRating(r)
                    setPage(1)
                }}
                />
            </div>
            </div>

            <div className="row">
            <div className="col-md-12 col-xs-12">
                <div className="form-group" style={{marginBottom:'10px'}}>
                <div className="vertical-offset-xxs">Select maturity range</div>
                <div className="select-wrapper">
                <select
                    id="corporates-top-sectors-maturity-range"
                    data-name="corporates-top-sectors-maturity-range"
                    className="form-control"
                    value={maturity}
                    onChange={(e) => {
                        setMaturity(e.target.value)
                        setPage(1)
                    }}>
                <option value="LT_3">Shorter term (&lt;3 years)</option>
                <option value="3_TO_5">Shorter term (3-5 years)</option>
                <option value="5_TO_10">Medium term (5-10 years)</option>
                <option value="10_TO_20">Longer term (10-20 years)</option>
                <option value="GT_20">Longer term (>20 years)</option>
                </select>
                </div>
                </div>
            </div>
            </div>
        </div>

        </div>
        </div>

        <Loading status={status}>
            <div className="equally-spaced">
            <div className="small-header">
            Total trades in the last trading day:
            </div>
            <div className="small-header text-right">
            {fmt.count(total)}
            </div>
            </div>

            <SectorRankings
                sectors={sectors}
                page={page}
                total={total}
                maturity={maturity} />
        </Loading>

        <hr aria-hidden="true" className="vertical-offset-xs" />

        <div className="row vertical-offset-sm">
            <div className="col-xs-12 col-sm-8">
                <Paging
                    dataName="corporates-top-sectors-paging"
                    total={sectors.length}
                    page={page}
                    setPage={setPage}
                    size={3} />
            </div>
            <div className="col-xs-12 col-sm-4 text-right">
                <Disclosures
                    dataName="corporates-top-sectors-disclosures-link"
                    html={DISCLOSURES} />
            </div>
        </div>

    </div>
    </React.Fragment>)
}

const DISCLOSURES=`
<p>
The advanced screening functionality within the Bond Resource Center enables users
to filter corporate bond offerings across 12 unique industry sectors.
The Sector Activity Search tool helps users identify and search offerings
from issuers within each corporate sector.
The sectors are ranked in descending order by number of trades based on TRACE-reported
corporate bond trade data from the previous trading day.
Each sector will display the number of trades from the previous day and the percentage
of total trades they comprise. The total number of trades is an aggregate value of
all sectors’ trades from the previous day.
<p>

<p>
Each sector listing will display the three top-traded issuers within each corresponding sector.
Users can curate a list of bond offers using this tool in two easy steps. To begin your search,
first choose your time horizon. The maturity dropdown filter at the top of the module will
default to shorter-term offerings (within three years), but you may want to select an alternate
maturity range aligned with your requirements. Finally, click an issuer name within a sector
listing to generate a search results page with offerings meeting your criteria.
<p>

<p class="text-small">
*Sector categories may include: Basic Materials, Consumer Goods, Consumer Services,
Financials, Healthcare, Industrials, Oil and Gas, Other, Technology, Telecommunications,
Transportation, and Utilities.
</p>
`